import { Injectable } from '@angular/core'
import { TrackingEvent } from './tracking'

/**
 * @ftr/foundation should not understand anything about the implementation of our analytics,
 * but sometimes we do want tracking events on things like buttons/validation etc.
 */
@Injectable()
export abstract class TrackingService {
  abstract track(data: TrackingEvent): void
}
